﻿window.cObjetSmsListeNoireMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "sms désinscrit"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouvelle désinscription"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') {
            txt = objet.data.adresse_email
        } else {
            txt = "désinscription"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "5px" }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-user-secret' title='Téléphone désinscrit'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.contentTemplatePopup = function (contentElement, option) {

    }

    this.hasScrollPopup = function () { return false }
    this.isPopupFullScreen = false
    //this.mShowPopup = function (optionPopup) {
    //    page.mAddPopup(objet.data)
    //}

}